import React, { useState, useEffect } from 'react';
// Api
import client from '../../api/client';
// Components
import BlogPostPreview from './BlogPostPreview';
import BlogPaginationButtons from './BlogPaginationButtons';
import { tempBlogPosts } from '../../utils/data/BlogData';
import ImageBannerCta from '../cta/ImageBannerCta';

function BlogPageMainContainer() {
  const [posts, setPosts] = useState(tempBlogPosts);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const postsPerPage = 10;

  useEffect(() => {
    // client
    //   .get(
    //     `${GET_BLOG_POSTS_API}?page=${currentPage}&limit=${postsPerPage}`,
    //     false
    //   )
    //   .then((res) => {
    //     setPosts(res.data.posts);
    //     if (res.data.posts.length <= 0) {
    //       setPosts(tempBlogPosts);
    //       setTotalPages(tempBlogPosts.length);
    //     }
    //     setTotalPages(res.data.totalPages);
    //   })
    //   .catch((err) => {
    //     setPosts(tempBlogPosts);
    //     setTotalPages(tempBlogPosts.length);
    //     console.error('Unable to retrieve user data', err);
    //   });
  }, [currentPage]);

  return (
    <main role='main' className='grid gap-12 pt-6 pb-12'>
      <section className='grid '>
        <div className='grid px-6 sm:px-8 md:px-12 lg:container lg:mx-auto gap-6'>
          {/* Blog Posts */}
          <section className='grid grid-cols-1 md:grid-cols-2 gap-6'>
            {posts.length > 0 ? (
              posts.map((post) => <BlogPostPreview key={post.id} post={post} />)
            ) : (
              <p className='text-center col-span-full'>No posts available</p>
            )}
          </section>

          {/* Pagination */}
          <BlogPaginationButtons
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      </section>

      {/* Cta */}
      <ImageBannerCta />
    </main>
  );
}

export default BlogPageMainContainer;
